import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { UnifiedServiceReportFilter, UnifiedServiceReportResponse } from '../models/dtos/unified-service-report';
import { PaginationFilter } from '../models/pagination-filter';

@Injectable({
  providedIn: 'root'
})
export class UnifiedServiceReportService {

  constructor(private http: HttpClient) { }

  getUnifiedServiceReport(filter: UnifiedServiceReportFilter, paginationFilter: PaginationFilter): Observable<UnifiedServiceReportResponse> {
    let params = new HttpParams();
    params = params.set('page', paginationFilter.page.toString());
    params = params.set('size', paginationFilter.size.toString());
    
    if (paginationFilter.sort && paginationFilter.order) {
      params = params.set('sort', `${paginationFilter.sort},${paginationFilter.order}`);
    }
    
    return this.http.post<any>(
      environment.apiHost + '/api-core/secure/reports/unified-services',
      filter,
      { params }
    ).pipe(
      map((response: any) => response as UnifiedServiceReportResponse)
    );
  }



  getDistinctServiceTypes(): Observable<string[]> {
    return this.http.get<string[]>(
      environment.apiHost + '/api-core/secure/reports/unified-services/service-types'
    );
  }
}